export const SmoothScroll = (e, id) => {
    e.preventDefault();
    document.getElementById(id).scrollIntoView({
      behavior: "smooth",
    });
  };